import { useTranslation } from 'react-i18next'
import SearchBar from './components/SearchBar'
import UrvTableContent from './components/UrvTableContent'
import TablePagination from './components/TablePagination'
import ExportDialog from './components/ExportDialog'
import useUrvData from './hooks/useUrvData'
import useUrvExport from './hooks/useUrvExport'
import WidgetPaper from '@/components/WidgetPaper'

const UrvTable = ({ ref }) => {
  const { t } = useTranslation()
  const {
    data,
    isLoading,
    page,
    size,
    searchInput,
    setSearchInput,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    totalCount
  } = useUrvData()

  const {
    openExportModal,
    setOpenExportModal,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    isExporting,
    handleExport
  } = useUrvExport()

  const handleSizeChange = (newSize) => {
    handleRowsPerPageChange({ target: { value: newSize } })
  }

  const handlePageChangeAdapter = (newPage) => {
    handlePageChange(null, newPage - 1)
  }

  return (
    <>
      <WidgetPaper
        ref={ref}
        title={t('urv')}
      >
        <SearchBar
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          onSearch={handleSearch}
          onOpenExport={() => setOpenExportModal(true)}
        />

        <UrvTableContent data={data} isLoading={isLoading} />

        <TablePagination
          page={page + 1}
          size={size}
          total={totalCount}
          totalPages={Math.ceil(totalCount / size) || 1}
          onPageChange={handlePageChangeAdapter}
          onSizeChange={handleSizeChange}
        />
      </WidgetPaper>
      <ExportDialog
        open={openExportModal}
        onClose={() => setOpenExportModal(false)}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        onExport={handleExport}
        isExporting={isExporting}
      />
    </>
  )
};

export default UrvTable
